var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Head',[_c('title',[_vm._v(_vm._s(_vm.title)+" - Bell Oldow, Inc.")]),_vm._v(" "),(_vm.desc)?_c('meta',{attrs:{"name":"description","content":_vm.desc}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }